import { canonicalizeSection, sectionPathSegment } from "./taskSections";

const SECTION_PATTERN =
  "task|engineering|delivery|review|activity|plan|handoff|overview|conversation";

function readTaskContext(search = "") {
  const params = new URLSearchParams(search.startsWith("?") || search.includes("=") ? search : "");
  return {
    discuss: params.get("discuss") || null,
    focus: params.get("focus") || null,
    item: params.get("item") || null,
  };
}

export function parseTaskLocation(pathname = "", search = "") {
  const context = readTaskContext(search);
  const reviewsMatch = String(pathname || "").match(/^\/repositories\/([^/]+)\/reviews\/?$/);
  if (reviewsMatch) {
    return {
      repositoryId: reviewsMatch[1],
      taskId: null,
      section: null,
      deliveryFocused: false,
      view: "reviews",
      ...context,
    };
  }
  const match = String(pathname || "").match(
    new RegExp(
      `^/repositories/([^/]+)(?:/tasks/(new|[^/]+))?(?:/(${SECTION_PATTERN}))?/?$`
    )
  );
  if (!match) {
    return { repositoryId: null, taskId: null, section: null, deliveryFocused: false, view: "tasks", ...context };
  }
  const rawSection = match[3] || null;
  const section = canonicalizeSection(rawSection);
  return {
    repositoryId: match[1] || null,
    taskId: match[2] || null,
    section,
    deliveryFocused: section === "delivery",
    view: "tasks",
    ...context,
  };
}

export function taskPath({ repositoryId, taskId, section, view, discuss, focus, item } = {}) {
  if (!repositoryId) return "/";
  let path = "";
  if (taskId === "new") path = `/repositories/${repositoryId}/tasks/new`;
  else if (!taskId && view === "reviews") path = `/repositories/${repositoryId}/reviews`;
  else if (!taskId) path = `/repositories/${repositoryId}`;
  else {
    const canonical = canonicalizeSection(section);
    path = canonical
      ? `/repositories/${repositoryId}/tasks/${taskId}/${sectionPathSegment(canonical)}`
      : `/repositories/${repositoryId}/tasks/${taskId}`;
  }
  const params = new URLSearchParams();
  if (discuss) params.set("discuss", discuss);
  if (focus) params.set("focus", focus);
  if (item) params.set("item", item);
  const query = params.toString();
  return query ? `${path}?${query}` : path;
}
